import { useCategoryLabel } from "@/i18n/categories";
import { categoryIcon } from "@/lib/categoryIcons";

// One fixed palette per business category, so every card in a category looks the same.
export const CATEGORY_PALETTE = {
  "Food & Beverage": { bg: "#3F0A1C", accent: "#F43F5E", soft: "#FECDD3" },
  Automotive: { bg: "#0F172A", accent: "#64748B", soft: "#CBD5E1" },
  Plumbing: { bg: "#082F35", accent: "#06B6D4", soft: "#A5F3FC" },
  Contractors: { bg: "#3B2606", accent: "#F59E0B", soft: "#FDE68A" },
  "Tuition Centers": { bg: "#1E1B4B", accent: "#6366F1", soft: "#C7D2FE" },
  Freelancers: { bg: "#2E1065", accent: "#8B5CF6", soft: "#DDD6FE" },
  "Beauty & Wellness": { bg: "#4A044E", accent: "#D946EF", soft: "#F5D0FE" },
  "Retail & Grocery": { bg: "#052E22", accent: "#10B981", soft: "#A7F3D0" },
  "Electrical & Aircond": { bg: "#1C1917", accent: "#EAB308", soft: "#FEF08A" },
  "Printing & Design": { bg: "#042F2E", accent: "#14B8A6", soft: "#99F6E4" },
  Penginapan: { bg: "#172554", accent: "#3B82F6", soft: "#BFDBFE" },
  "Majlis & Perkahwinan": { bg: "#431407", accent: "#FB923C", soft: "#FED7AA" },
  "Lain-lain": { bg: "#1F2937", accent: "#9CA3AF", soft: "#E5E7EB" },
};

const FALLBACK = CATEGORY_PALETTE["Lain-lain"];

/** Styled CSS business-card placeholder — renders instantly, never fails to load. */
export const CardVisual = ({ listing, compact = false }) => {
  const catLabel = useCategoryLabel();
  const style = CATEGORY_PALETTE[listing.category] || FALLBACK;
  const Icon = categoryIcon(listing.category);
  const words = (listing.business_name || "").split(" ");
  const initials = words.slice(0, 2).map((w) => w[0] || "").join("").toUpperCase();

  return (
    <div
      data-testid={`card-visual-${listing.id}`}
      className="relative flex h-full w-full flex-col justify-between overflow-hidden"
      style={{ backgroundColor: style.bg }}
    >
      <span
        className="absolute -right-10 -top-14 h-40 w-40 rounded-full"
        style={{ backgroundColor: style.accent, opacity: 0.2 }}
        aria-hidden="true"
      />
      <div className={`flex items-start justify-between ${compact ? "p-2.5" : "p-4 sm:p-5"}`}>
        <span
          className={`inline-flex items-center justify-center rounded font-display font-bold text-white ${
            compact ? "h-6 w-6 text-[10px]" : "h-9 w-9 text-xs"
          }`}
          style={{ backgroundColor: style.accent }}
        >
          {initials || "MY"}
        </span>
        <Icon
          className={compact ? "h-4 w-4" : "h-6 w-6"}
          style={{ color: style.soft, opacity: 0.85 }}
          aria-hidden="true"
        />
      </div>
      <div className={`relative ${compact ? "p-2.5" : "p-4 sm:p-5"}`}>
        <p
          className={`font-display font-bold leading-tight text-white ${compact ? "line-clamp-1 text-[11px]" : "line-clamp-1 text-[15px] sm:text-base"}`}
        >
          {listing.business_name}
        </p>
        {!compact && (
          <>
            <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.18em]" style={{ color: style.soft }}>
              {catLabel(listing.category)}
            </p>
            <p className="mt-1 truncate text-[11px]" style={{ color: style.soft }}>
              {listing.phone_number} · {listing.district}
            </p>
          </>
        )}
      </div>
      <span className="absolute bottom-0 left-0 h-1 w-full" style={{ backgroundColor: style.accent }} />
    </div>
  );
};
